"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ZH_CN = ['秒', '分钟', '小时', '天', '周', '个月', '年'];
function default_1(diff, idx) {
    if (idx === 0)
        return ['刚刚', '片刻后'];
    var unit = ZH_CN[~~(idx / 2)];
    return [diff + " " + unit + "\u524D", diff + " " + unit + "\u540E"];
}
exports.default = default_1;
//# sourceMappingURL=zh_CN.js.map